import { projectRules } from '@/helpers/rulesModules/buildProjectRules';
import { createRuleHelper } from '@/helpers/rulesHelper';

// RULES DICTIONARY =========================================================
const rules = projectRules;

export default createRuleHelper({ rules });
